import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";

export default function UserGrowthBarChart({ rawGrowth, selectedYear }) {
    // Get theme colors from CSS variables
    const getThemeColor = (variable) => {
        if (typeof window !== 'undefined') {
            return getComputedStyle(document.documentElement)
                .getPropertyValue(variable)
                .trim() || '#000';
        }
        return '#000';
    };

    const primaryColor = getThemeColor('--primary-solid');
    const blackText = getThemeColor('--black-text') || '#1f2937';
    const gridColor = '#e5e7eb'; // gray-200

    // Use selectedYear instead of current year
    const fullGrowth = Array.from({ length: 12 }).map((_, index) => {
        const monthName = new Date(selectedYear, index).toLocaleDateString("en-US", {
            month: "short",
        });

        return {
            month: monthName,
            count: 0,
        };
    });

    // Map API data correctly
    rawGrowth.forEach((item) => {
        const monthIndex = item.month - 1;
        if (fullGrowth[monthIndex]) {
            fullGrowth[monthIndex].count = item.count;
        }
    });

    return (
        <div className="w-full overflow-x-auto">
            <div className="min-w-[750px] h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={fullGrowth}>
                        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
                        <XAxis 
                            dataKey="month" 
                            stroke={blackText} 
                            style={{ fontSize: '12px' }}
                        />
                        <YAxis 
                            stroke={blackText} 
                            style={{ fontSize: '12px' }}
                        />
                        <Tooltip
                            contentStyle={{
                                background: "white",
                                border: `2px solid ${primaryColor}`,
                                borderRadius: "8px",
                                color: blackText,
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            }}
                            labelStyle={{ 
                                color: primaryColor,
                                fontWeight: "bold",
                                marginBottom: "4px"
                            }}
                            itemStyle={{ color: blackText }}
                        />
                        <Bar
                            dataKey="count"
                            fill={primaryColor}
                            barSize={35}
                            radius={[6, 6, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
